/** Finance console routes (§16.2 Finance) — appended to the shell registry with one atomic edit. */
import type { ConsoleRoute } from '../index';
import { LedgerPage } from './LedgerPage';
import { PayoutsPage } from './PayoutsPage';
import { ReconciliationPage } from './ReconciliationPage';
import { RefundsPage } from './RefundsPage';

const FINANCE_VIEW = [
  'finance.ledger.read',
  'finance.reconcile',
  'finance.refund',
  'finance.payout.approve',
] as const;

export const financeRoutes: ConsoleRoute[] = [
  {
    path: 'finance',
    handle: { permission: FINANCE_VIEW, title: 'Finance — reconciliation' },
    element: <ReconciliationPage />,
  },
  {
    path: 'finance/refunds',
    handle: { permission: FINANCE_VIEW, title: 'Finance — refunds' },
    element: <RefundsPage />,
  },
  {
    path: 'finance/payouts',
    handle: { permission: FINANCE_VIEW, title: 'Finance — payouts' },
    element: <PayoutsPage />,
  },
  {
    path: 'finance/ledger',
    handle: { permission: FINANCE_VIEW, title: 'Finance — ledger' },
    element: <LedgerPage />,
  },
];
